module.exports = __webpack_public_path__ + "static/img/performance03.c64b1ea9.jpg";